import { useQuery } from "@tanstack/react-query";
import { appService } from "/app/src/services";
import { buildParams } from "/app/src/helpers";
import ClickableNavItem from "./clickableNavItem";
import { App } from "/app/src/models";

/**
 *
 * @returns The apps sidemenu component
 */
export default function Apps() {
  const { data: availableApps } = useQuery({
    queryKey: [
      "apps",
      "[or]Data Push;Data Pull;Variance;Displays;Order Builder;Order Processor",
      "[nor]0;3",
    ],
    queryFn: () =>
      appService.getAll(
        buildParams({
          status: "[nor]0;3",
          orderby: "name",
          name: "[or]Data Push;Data Pull;Variance;Displays;Order Builder;Order Processor",
        }),
      ),
    initialData: { apps: [] },
    select: (data: { apps: App[] }) => {
      return data.apps;
    },
  });

  /**
   *
   * @param name string
   * @returns Generates icon based on the app name
   */
  const iconGenerator = (name: string) => {
    switch (name) {
      case "Data Push":
        return "DataPushIcon";
      case "Data Pull":
        return "DataPullIcon";
      case "Variance":
        return "VarianceIcon";
      case "Displays":
        return "DisplaysIcon";
      case "Order Builder":
        return "OrderBuilderIcon";
      case "Order Processor":
        return "OrderProcessorIcon";
      default:
        return null;
    }
  };

  return (
    <>
      {availableApps.map((app) => (
        <ClickableNavItem
          key={app.id}
          icon={iconGenerator(app.name)}
          navTo={`/apps/${app.id}`}
        />
      ))}
    </>
  );
}
